import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';
import './startShiftModal.css';

const StartShiftModal = ({ visible, onClose, onSuccess, user = null, title = 'Start Shift' }) => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState(user?.email || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Reset form when modal opens/closes or user changes
  useEffect(() => {
    if (visible) {
      setEmail(user?.email || '');
      setPassword('');
      setError('');
    }
  }, [visible, user]);

  const validateForm = () => {
    if (!email?.trim()) {
      setError('Email is required');
      return false;
    }

    if (!password?.trim()) {
      setError('Password is required');
      return false;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return false;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return false;
    }

    return true;
  };

  const handleLogin = async () => {
    setError('');

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const apiService = new ApiService();
      const response = await apiService.post('USER_LOGIN', {
        email: email.trim(),
        password,
      });
      debugger;
      if (response?.data?.data?.accessToken) {
        // Store token
        localStorage.setItem('Token', response.data.data?.accessToken);

        // Store company info if available
        if (response?.data?.data?.userCompanies?.[0]) {
          localStorage.setItem('Company', JSON.stringify(response.data.data.userCompanies[0]));
        }

        console.log('🔐 Login successful');

        // Call success callback if provided
        if (onSuccess) {
          onSuccess(response.data?.data);
        } else {
          // Default navigation
          window.location.href = '/cashier/home';
        }

        // Close modal
        onClose();
      } else {
        setError('Login failed: Invalid response from server');
      }
    } catch (err) {
      console.error('Login error:', err);

      // Handle different types of errors
      if (err.response?.status === 401) {
        setError('Invalid email or password');
      } else if (err.response?.status >= 500) {
        setError('Server error. Please try again later.');
      } else if (err.message) {
        setError(err.message);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleLogin();
    }
  };

  const handleClose = () => {
    if (!loading) {
      setPassword('');
      setEmail(user?.email || '');
      setError('');
      onClose();
    }
  };

  if (!visible) return null;

  const isFormValid = email.trim() !== '' && password.trim() !== '';

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2 className="modal-title">{title}</h2>
        {error && <p className="error-text">{error}</p>}
        <input
          className="modal-input"
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={loading || (user && user.email)}
        />
        <input
          className="modal-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />
        <button className={`modal-button ${!isFormValid || loading ? 'disabled' : ''}`} disabled={!isFormValid || loading} onClick={handleLogin}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <button className="cancel-button" onClick={handleClose} disabled={loading}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default StartShiftModal;
